import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '../../../../../components/Flex';
import { useFilters } from '../../../../../contexts/FiltersContext';
import FilterCategoryHotel from './components/FilterCategoryHotel';
import FilterHotel from './components/FilterHotel';
import FilterNightsQuantities from './components/FilterNightsQuantities';
const AsideFilters = ({ availableFilters }) => {
  const { t } = useTranslation('translations');
  const { handleResetFilters } = useFilters();
  const [isOpen, setIsOpen] = useState();

  return (
    <>
      <div
        className={`filters-opener${isOpen ? ' opened-filters' : ''}`}
        onClick={() => setIsOpen((state) => !state)}
      >
        {isOpen ? <i className='fa fa-times' /> : <i className='fa fa-filter' />}
        <span>{t(isOpen ? 'filters.close' : 'packages.filters')}</span>
      </div>
      <Flex className={`aside-filters__wrapper${isOpen ? ' open-filters' : ''}`} vertical>
        <Flex style={{ justifyContent: 'space-between' }}>
          <p className='aside-filters__title'>{t('filters.title')}</p>
        </Flex>
        <Flex className='aside-filters__filters' vertical>
          {!!availableFilters.hotelCategories && (
            <FilterCategoryHotel data={availableFilters.hotelCategories} />
          )}
          {!!availableFilters.hotels && <FilterHotel data={availableFilters.hotels} />}
          {!!availableFilters.nightsQuantities && (
            <FilterNightsQuantities data={availableFilters.nightsQuantities} />
          )}
        </Flex>
        <button className='aside-filters__clean-btn' onClick={handleResetFilters}>
          Limpiar filtros
        </button>
      </Flex>
    </>
  );
};

export default AsideFilters;
